export function showLoading(containerId: string): void {
  const container = document.getElementById(containerId);
  if (!container) return;

  container.innerHTML = `
    <div class="flex items-center gap-2 text-gray-400 text-sm">
      <div class="h-4 w-4 animate-spin rounded-full border-2 border-gray-200 border-t-gray-600"></div>
      Loading...
    </div>
  `;
}

export function showError(containerId: string, message: string): void {
  const container = document.getElementById(containerId);
  if (!container) return;

  container.innerHTML = `
    <div class="bg-red-50 border border-red-200 rounded-lg p-3 text-sm text-red-700">
      ${escapeHtml(message)}
    </div>
  `;
}

export function showEmpty(containerId: string, message: string): void {
  const container = document.getElementById(containerId);
  if (!container) return;

  container.innerHTML = `
    <p class="text-sm text-gray-500">${escapeHtml(message)}</p>
  `;
}

export function setContent(containerId: string, html: string): void {
  const container = document.getElementById(containerId);
  if (!container) return;
  container.innerHTML = html;
}

export function makeTable(headers: string[], rows: string[][]): string {
  let html = '<div class="overflow-x-auto"><table class="w-full text-sm border-collapse">';

  // Header
  html += '<thead><tr>';
  for (const header of headers) {
    html += `<th class="text-left px-4 py-2 border-b border-gray-200 text-gray-500 font-medium">${header}</th>`;
  }
  html += '</tr></thead>';

  // Body
  html += '<tbody>';
  for (const row of rows) {
    html += '<tr>';
    for (const cell of row) {
      html += `<td class="px-4 py-2 border-b border-gray-100">${cell}</td>`;
    }
    html += '</tr>';
  }
  html += '</tbody></table></div>';

  return html;
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}
